import { apiAxios } from '@/api'
import { plural } from '../../lib/plural'
import type { PollSchedule } from './polling'

export interface AutoCategorizedTransaction {
  id: number
  date: string
  merchant: string
  category: string
  amount: string
}

export interface AutoCategorizationStatus {
  pending: boolean
  categorizedCount: number
  categorized: AutoCategorizedTransaction[]
}

export const POLL_SCHEDULE: PollSchedule = {
  steps: [
    [20_000, 2_000],
    [60_000, 5_000],
  ],
  restMs: 15_000,
}

const EMPTY: AutoCategorizationStatus = {
  pending: false,
  categorizedCount: 0,
  categorized: [],
}

export const fetchAutoCategorizationStatus =
  async (): Promise<AutoCategorizationStatus> => {
    const { data } = await apiAxios.get<{
      autoCategorization?: AutoCategorizationStatus
    }>('/finances/api/v1/plaid/sync-status', {
      params: { autoCategorizationDetails: true },
    })
    return data.autoCategorization ?? EMPTY
  }

export const byMerchant = (
  transactions: AutoCategorizedTransaction[]
): AutoCategorizedTransaction[] =>
  [...transactions].sort(
    (a, b) =>
      a.merchant.localeCompare(b.merchant) || a.date.localeCompare(b.date)
  )

export const toLabel = (count: number): string =>
  count === 0
    ? 'No transactions needed a category'
    : `Put a category on ${plural(count, 'transaction')}`

export const toShownOf = (status: AutoCategorizationStatus): string | null =>
  status.categorizedCount > status.categorized.length
    ? `Showing ${status.categorized.length} of ${status.categorizedCount}`
    : null

export const toOutcome = (
  status: AutoCategorizationStatus,
  timedOut: boolean
): string => {
  const count = status.categorizedCount
  if (timedOut)
    return `Heard is still putting categories on my transactions. It has done ${count} so far.`
  if (count === 0)
    return 'Heard finished, and none of my transactions needed a category.'
  return `Heard finished and put a category on ${plural(count, 'transaction')}.`
}
